import React, { useState, useEffect, Fragment, useRef } from 'react'
import Image from 'next/image'
import classNames from 'classnames'
import Slider from 'react-slick'
import { MediaCarouselSettings } from '@/utils/carourselConfig'
import styles from '@/styles/components/speaker.module.scss'

import Link from 'next/link'
import { BsArrowRight } from 'react-icons/bs'
import { IconContext } from 'react-icons'
import { MediaPlayer } from './MediaPlayer'

const Media = ({ videoData = [] }) => {
  const [data, setData] = useState(videoData)
  const [videoUrl, setVideoUrl] = useState(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const [videoURLs, setVideoURLs] = useState([])
  const [isMuted, setIsMuted] = useState(true)
  const [selected, setSelected] = useState(0)
  
  const [autoPlay, setAutoPlay] = useState(false)
  const [videoPlayerClass, setVideoPlayerClass] = useState('video-top-layer ')
  const [currentSlide, setCurrentSlide] = useState(0)
  const sliderRef = useRef()
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
    arrows: false,
    swipeToSlide: true,
  }

  useEffect(() => {
    if (videoData.length) {
      const result = videoData?.map((item) => item?.url)
      setVideoURLs(result)
      setSelected(0)
      setData(videoData)
      setVideoUrl([...videoData].shift()?.url)
      setSelectedItem([...videoData].shift())
    }
  }, [videoData])

  window.addEventListener('resize', () => {
    const resutl = document.body.clientWidth
    if (resutl <= 479) {
      setIsMuted(true)
      return
    }
    setIsMuted(false)
  })

  const isVideo = () => {
    if (!videoUrl) return false
    return (
      videoUrl.startsWith('https://player.vimeo') ||
      videoUrl.startsWith('https://www.youtube') ||
      videoUrl.startsWith('https://dca.unitedtalent.com')
    )
  }

  const onVideoPlayEnd = () => {
    setAutoPlay(true)

    setSelected((prev) => {
      if (sliderRef && sliderRef.current) {
        sliderRef.current.slickGoTo(prev + 1)
      }
      if (prev === videoURLs.length - 1) {
        setVideoUrl(videoURLs[videoURLs.length - 1])
        setSelectedItem(data[videoURLs.length - 1])
        return prev
      }
      setVideoUrl(videoURLs[prev + 1])
      setSelectedItem(data[prev + 1])
      setCurrentSlide(prev + 1)
      return prev + 1
    })
  }

  const getPosterUrlByVideoUrl = () => {
    if (videoUrl) {
      const selectedVideoData = videoData?.filter((item) => {
        return item.url === videoUrl
      })
      return `https:${selectedVideoData[0]?.fields?.file?.url}`
    }
  }
  return (
    <section>
      <div className="flex flex-wrap heading-top-space">
        <h1 className="tagline-font text-white tracking-wide md:text-2xl text-xl  mb-2.5">MEDIA</h1>
        <div className="flex flex-wrap w-full lg:mb-0">
          <div className="hidden w-full lg:w-4/5 xs:block">
            <div className="relative p-[28.25%]">
              {videoUrl && isVideo()
                ? document.body.clientWidth > 478 && (
                    <MediaPlayer
                      autoPlay={autoPlay}
                      videoUrl={videoUrl}
                      posterUrl={getPosterUrlByVideoUrl()}
                      onEnded={onVideoPlayEnd}
                    />
                  )
                : selectedItem &&
                  selectedItem.fields?.file?.url &&
                  selectedItem.url && (
                    <div>
                      <Link href={selectedItem.url} legacyBehavior>
                        <a target="_blank">
                          <Image
                            src={`https:${selectedItem.fields?.file?.url}`}
                            alt="Picture of the author"
                            layout="fill"
                            className="absolute top-0 left-0 videoplayer"
                            objectFit="cover"
                            quality={100}
                          />
                          <div className=" bg-black/75 absolute py-2 px-4 min-w-full bottom-0 left-0 flex justify-between items-center ">
                            <h2 className="text-lg tagline-font whitespace-nowrap font-bold hover:underline underline-offset-2">
                              {selectedItem?.fields?.title}
                            </h2>
                            <IconContext.Provider
                              value={{
                                size: '1.5em',
                              }}
                            >
                              <BsArrowRight className="inline-block ml-4 text-white group-hover:text-black" />
                            </IconContext.Provider>
                          </div>
                        </a>
                      </Link>
                    </div>
                  )}
            </div>
          </div>
          {/* Video player ends here  */}
          <div
            id="custom-scroll-bar"
            className="flex-col justify-items-center hidden lg:block flex-wrap lg:w-1/5 xl:max-h-[570px] lg:max-h-[400px] max-h-[570px] text-white overflow-auto lg:px-4 lg:py-0 xs:mb-4"
          >
            {data.map((item, index) => (
              <Fragment key={index}>
                {item.fields && (
                  <div
                    className={classNames(
                      'p-4 w-full',
                      videoUrl == item?.url && selected == index && 'bg-[#404040]'
                    )}
                  >
                    <div className="flex flex-col flex-wrap items-center justify-items-center">
                      <div
                        className={classNames(
                          'relative w-full h-24 overflow-hidden cursor-pointer',
                          videoUrl == item?.url && 'border-2 border-white '
                        )}
                      >
                        {item?.fields?.file?.url && (
                          <Image
                            src={`https:${item?.fields?.file?.url}`}
                            alt="Picture of the author"
                            layout="fill"
                            objectFit="cover"
                            quality={100}
                            onClick={() => {
                              setSelected(videoURLs?.indexOf(item?.url))
                              setVideoUrl(item?.url)
                              setSelectedItem(item)
                              setCurrentSlide(index)
                            }}
                          />
                        )}
                      </div>
                      {item?.fields?.title && (
                        <div className="w-full pt-2">
                          <h2 className="font-medium text-xs text-[#C1C1C1]">
                            {item?.fields?.title}
                          </h2>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Fragment>
            ))}
          </div>
          {/* Mobile & Tab View starts here  */}
          <div
            className={classNames(
              'speaker-list mt-5 w-full slide-w hidden xs:block',
              styles.mediaContainer
            )}
          >
            <Slider infinite={videoData.length > 4 ? true : false} {...MediaCarouselSettings}>
              {data?.map((item, i) => (
                <Fragment key={i}>
                  {item.fields && (
                    <div
                      className={classNames(
                        'p-2',
                        videoUrl == item?.url && selected == i && 'bg-[#404040]'
                      )}
                    >
                      <div
                        className={classNames(
                          'relative h-24 overflow-hidden cursor-pointer',
                          videoUrl == item?.url && 'lg:border-2 xs:border-4 border-white'
                        )}
                      >
                        {item?.fields?.file?.url && (
                          <Image
                            src={'https:' + item?.fields?.file?.url}
                            alt="Picture of the author"
                            fill
                            objectFit="contain"
                            className="mt-2 mb-3 shadow-lg cursor-pointer "
                            quality={100}
                            onClick={() => {
                              setSelected(videoURLs?.indexOf(item?.url))
                              setSelectedItem(item)
                              setVideoUrl(item?.url)
                              setCurrentSlide(i)
                            }}
                          />
                        )}
                      </div>
                      {item?.fields?.title && (
                        <div className="w-full pt-2">
                          <h2 className="font-medium text-xs text-[#C1C1C1] truncate">
                            {item?.fields?.title}
                          </h2>
                        </div>
                      )}
                    </div>
                  )}
                </Fragment>
              ))}
            </Slider>
          </div>
        </div>
        {/* Extra small Mobile view start here  */}

        <div
          className="flex flex-col flex-wrap items-center w-full xs:hidden relative pb-14"
          id="mobile"
        >
          <div className="flex flex-col items-center h-full text-center w-full">
            <div className="relative w-full react-player-mobile-dots">
              <Slider
                ref={sliderRef}
                {...settings}
                beforeChange={(cur, next) => {
                  setVideoPlayerClass('video-top-layer')
                  setVideoUrl(videoURLs[next])
                  setAutoPlay(true)
                  setSelectedItem(data[next])
                  setCurrentSlide(next)
                  setSelected(videoURLs?.indexOf(videoURLs[next]))
                }}
              >
                {data?.map((item, i) => (
                  <span key={i}>
                    {data?.length > 0 && (
                      <div key={i}>
                        <div>
                          {videoUrl && isVideo(videoUrl)
                            ? i == currentSlide &&
                              document.body.clientWidth <= 479 && (
                                <MediaPlayer
                                  key={videoUrl}
                                  autoPlay={autoPlay}
                                  videoUrl={videoUrl}
                                  posterUrl={getPosterUrlByVideoUrl()}
                                  onEnded={onVideoPlayEnd}
                                  className="top-0 left-0 mobile-videoplayer"
                                />
                              )
                            : selectedItem &&
                              selectedItem.fields?.file?.url &&
                              selectedItem.url && (
                                <div className="top-0 left-0">
                                  <Link href={selectedItem.url} legacyBehavior>
                                    <a target="_blank">
                                      <Image
                                        src={`https:${selectedItem.fields?.file?.url}`}
                                        alt="Picture of the author"
                                        height={0}
                                        width={450}
                                        quality={100}
                                      />
                                    </a>
                                  </Link>
                                </div>
                              )}
                        </div>
                        <div
                          className={videoPlayerClass}
                          onClick={() => {
                            setVideoPlayerClass('video-top-layer-1')
                          }}
                        ></div>
                        <div className="flex flex-wrap w-full pt-3.5 pb-5">
                          <h2 className="font-medium text-xs text-[#C1C1C1] text-left">
                            {item?.fields?.title}
                          </h2>
                        </div>
                      </div>
                    )}
                  </span>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Media